export default __webpack_public_path__ + "assets/images/f71a3ff93a7895fd97b01f390ec170e8.jpg";